/**
 * KAN-863: можно ли запускать звонок через платформу с учётом номера кабинета.
 * Backend отдаёт cabinet_has_call_number в /auth/me: false - номера для звонков
 * нет, кнопка "Позвонить" выключена; нет поля (старый backend) - звонить можно.
 */
import { useCurrentUser, type CurrentUser } from '@/hooks/useCurrentUser';

export const NO_CABINET_CALL_NUMBER_HINT = 'В кабинете не подключён номер для звонков';
export const NO_CABINET_CALL_NUMBER_SHORT = 'Номер для звонков не подключён';

/** Звонок блокирует только явный false; undefined/null трактуем как "есть". */
export function cabinetHasCallNumber(user: Pick<CurrentUser, 'cabinet_has_call_number'> | null | undefined): boolean {
  return user?.cabinet_has_call_number !== false;
}

export function useCabinetHasCallNumber(): boolean {
  const { data } = useCurrentUser();
  return cabinetHasCallNumber(data);
}
